import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import DocumentTitle from 'react-document-title'
import CompanyTasksList from './CompanyTasksList'

const companyTasksBreadCrumbs: Array<PageLink> = [
  {
    title: 'Company Tasks',
    path: '/company_tasks/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const CompanyTasksPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | Company Tasks'}
              ></DocumentTitle>
              <PageTitle breadcrumbs={companyTasksBreadCrumbs}>Company Tasks</PageTitle>
              <CompanyTasksList />
            </>
          }
        />
        <Route index element={<Navigate to='/company_tasks/list' />} />
      </Route>
    </Routes>
  )
}

export default CompanyTasksPage
